import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

let termsOne = [
    '1. Scope of this Policy',
    '2. Agreement to Privacy Policy and Terms',
    '3. Effective Date and Changes to this Notice',
    '4. Collection of Information',
    '5. How We Use and Share the Information We Collect',
    '6. Your Privacy Choices',
    '7. How We Store and Safeguard Your Information',
    '8. How We Communicate with You',
    '9. California Do-Not-Track Disclosure',
    '10. Links to Third Parties',
    '11. Contact Us',
]

let termsTwo = [
    'First and last name',
    'Email address',
    'Phone number',
    'Emergency contact data',
    'Billing and shipping addresses',
    'Address for provision of services',
    'Payment information',
    'Order history',
    'IP Address',
    'Account password',
    'Geolocation information',
    'Referral code',
    'Mobile contact and calendar data',
    'Social media account information'
]

let termsThree = [
    'Location',
    'Stripe ID',
    'Bank account information',
    'Licensing Information',
    'Photo ID',
]

let termsFour = [
    'To provide and maintain our Platform;',
    'To notify you about changes to our Platform,',
    'To allow you to participate in interactive features of our Platform when you choose to do so, such as our live chat function;',
    'To provide customer support;',
    'To gather analysis or valuable information so that we can improve our Platform;',
    'To monitor the usage of our Platform;',
    'To detect, prevent and address technical issues; and',
    'To provide you with news, special offers and general information about our services, unless you have opted not to receive such information.',
]

class CancellationPolicyAlert extends React.Component {
    handleClose = () => {
        this.props.close();
    };

    cancellationPrivacyContent = () => {
        var description = {
            margin: 5,
            alignSelf: 'center',
            fontSize: 17,
            paddingHorizontal: 10
        };

        var textUnderline = {
            textDecorationLine: 'underline',
            fontWeight: '700'
        };
        var textBold = {
            fontWeight: '700'
        };
        var textItalic = {
            fontStyle: 'italic',
            marginLeft: 30
        };
        var mb10 = {
            marginBottom: 10,
            marginTop: 10
        };
        var mb20 = {
            marginBottom: 20
        };
        var mt40 = {
            marginTop: 40
        }
        return (
            <div>
                <p style={{
                    textAlign: 'center',
                    fontSize: 16,
                    fontWeight: '700'
                }}>
                    EZPRO HOME SERVICES
                </p>
                <p style={{
                    textAlign: 'center',
                    fontSize: 16,
                    fontWeight: '700'
                }}>
                    PRIVACY POLICY
                </p>
                <div style={{
                    margin: 20
                }}>
                    <p style={mb20}>
                        Last updated: June 22, 2022
                    </p>
                    <div style={{
                        marginBottom: 20
                    }}>
                        {termsOne.map((term) => {
                            return (
                                <div style={{
                                    marginLeft: 20,
                                }}>
                                    <p style={{
                                        fontWeight: '700'
                                    }}>{term}</p>
                                </div>
                            )
                        })}
                    </div>
                    <p style={{ ...textUnderline, ...mb10 }}>
                        1. Scope of this Policy
                    </p>
                    <p>{`This   Privacy   Policy   describes   information   that   PoM   Home   Services,   Inc.,   which   is   doing business as ezPro Home Services, and its subsidiaries and affiliates (collectively, “ezPro”, “we”, “us”, or “our”) collect, use, share, and store, including personal information (i.e., information that identifies you, such as your name, email address or billing information, or other data that can be reasonably used to infer this information).  Any capitalized terms used herein but not defined shall have the meaning assigned to them in the ezPro Terms of Use. 
                          
        This document focuses on information related to the operation of the website (“Site”) and mobile application (“App”), collectively referred to as the Platform.`}</p>

                    <p style={{ ...textUnderline, ...mb10 }}>
                        2. Agreement to Privacy Policy and Terms
                    </p>
                    <p>
                        All activities which you engage in through the Platform are voluntary. You are not required to
                        provide any personal information to us unless you choose to access features of the Platform
                        which require such information. If you do not agree with the terms of this Privacy Policy or our
                        Terms of Use, then you should immediately discontinue use of the Platform without providing us
                        any personally identifiable information.</p>


                    <p style={{ ...textUnderline, ...mb10 }}>
                        3. Effective Date and Changes to this Policy
                    </p>
                    <p> This Privacy Policy is effective as of the date above and will remain in effect until a new notice
                        supersedes it. We may choose to update this policy at our discretion, so you should check this
                        page periodically as the terms may change from time to time. The most recent version of the
                        policy will be reflected by the “last updated” date noted at the top of the page. In the event of a
                        major change to this Privacy Policy, we will provide a conspicuous message either through the
                        Platform or via an email address associated with your Account informing you of the change.
                        Your affirmative consent or continued use of the Platform will constitute your acknowledgment
                        of the notice in its current version and your understanding of the terms of the Policy</p>

                    <p style={{ ...textUnderline, ...mb10 }}>
                        4. Collection of Information
                    </p>
                    <p>EzPro collects information about you through the Platform in several ways.</p>
                    <p style={{ ...textBold, ...textItalic }}>4.1 Information you provide</p>
                    <p> When you create an account, make a reservation, or enter information on the Platform, we may
                        collect personal information from you including your:</p>
                    <div style={{
                        marginBottom: 20
                    }}>
                        {termsTwo.map((term) => {
                            return (
                                <div style={{
                                    marginLeft: 20,
                                }}>
                                    <p style={{
                                        fontWeight: '700'
                                    }}>{'\u2022'} {term}</p>
                                </div>
                            )
                        })}
                    </div>
                    <p> This information is collected via registration and feedback forms, when you make a reservation,
                        and through our marketing channels.</p>

                    <p style={{ ...textBold, ...textItalic }}>4.2 Mailing list communications</p>
                    <p>When you sign up for the Platform, you may choose to add your email address to our mailing
                        list.     This   email   address   may   be   used   to   send   you   news   about   the   Platform,   surveys,   or
                        promotions. We may use one or more service providers to administer these messages, but we
                        will   not   share   your   email   address   with   spammers   or   any   other   third   parties   without   your
                        permission.</p>

                    <p style={{ ...textBold, ...textItalic }}>4.3 Reservation and Login Information </p>
                    <p>
                        After   you   create   an   account,   we   may   store   your   name,   billing   address,   and   address   for
                        performance of services (if applicable).   If you make a reservation through the Platform, we
                        request   that   you   provide   your   name,   email   address,   billing   address,   credit   card   information,
                        telephone   number,   the   location   for   performance   of   the   services,   and   any   other   information
                        necessary to complete  the  transaction, which we  may also store. Our credit  card processing
                        service provider, Stripe, will collect and store full payment card information from you when you
                        make a reservation until the services are completed. We may store this information for as long as
                        reasonably necessary to complete the transaction and maintain your records
                    </p>

                    <p style={{ ...textBold, ...textItalic }}>4.4 Information we collect through your use of the Platform</p>
                    <p style={textItalic}>4.4.1 Device Information</p>
                    <p>ezPro does not collect, any information from your search engine history or emails.
                        {" "}
                        We   may   automatically   collect   certain   information   about   the   computer   or   devices   (including
                        mobile devices) you use to access the Platform.   For example, we may collect and analyze
                        information such as (a) IP addresses, geolocation information, unique device identifiers and other
                        information   about   your   mobile   phone   or   other   mobile   device(s),   browser   types,   browser
                        language, operating system, the state or country from which you accessed the Platform; and (b)
                        information related to the ways in which you interact with the Platform, such as: referring and
                        exit pages and URLs, platform type, the number of clicks, domain names, landing pages, pages
                        and content viewed and the order of those pages, the amount of time spent on particular pages,
                        the date and time you used the Platform, the frequency of your use of the Platform, error logs,
                        and other similar information. As described further below, we may use third-party analytics
                        providers   and   technologies,   including   cookies   and   similar   tools,   to   assist   in   collecting   this
                        information.</p>

                    <p style={textItalic}>4.4.2 Analytics</p>
                    <p>We may also collect general information resulting from your activity on the Site, including your
                        preferences and other tendencies. This includes anonymous “traffic data” or tracking information
                        provided by the website’s host or similar provider of such information (i.e., Google Analytics)
                        that does not personally identify you but may be helpful for marketing purposes or for improving
                        the services we offer. Analytics is the process of collecting, analyzing, and reporting aggregate
                        data. This information may include which pages are visited, in what order the pages are visited,
                        when a visitor or user accesses a page, how long they may stay on a particular page, and where
                        they are located. It may also provide information about what browser, network, or device is used
                        to   visit   our   Site.   To   learn   more   about   Google   Analytics   and   how   to   opt   out,   please   visit
                        www.google.com/analytics/learn/privacy.html.
                        In addition, when you visit or use our Site, we may also log your anonymous IP addresses, a
                        unique identifier for your computer or other access device. This helps us diagnose problems with
                        our server, to administer our Platform, or to display the content according to your preferences.</p>

                    <p style={textItalic}>4.4.3 Cookies and Web Beacons </p>
                    <p>A cookie is a small string of information that the website you visit transfers to your computer for
                        identification   purposes.     Cookies   can   be   used   to   follow   your   activity   on   the   Site,   and   that
                        information helps websites to understand your preferences and improve and personalize your
                        website experience.  Cookies are also used for such activities as remembering your username and
                        password.  You can turn off all cookies in the event you prefer not to receive them.  You can also
                        have   your   computer   warn   you   whenever   cookies   are   being   used.     There   are   also   software
                        products available that can manage cookies for you.  Please be aware, however, that when you
                        choose to reject cookies, you may lose access to certain features of our Site.

                        Most cookies are “session cookies” which means that they are automatically deleted at the end of
                        each session. Most browsers are initially set to accept cookies.   You can set your browser to
                        notify you when you receive a cookie, giving you a chance to decide whether or not to accept it.
                        If  you  are   interested  in  more   information  about   interest-based  advertising  and  how  you  can
                        generally control cookies from being put on your computer to deliver tailored advertising, you
                        may visit the Network Advertising Initiative’s Consumer Opt-Out link, the Digital Advertising
                        Alliance’s   Consumer   Opt-Out   link  or  TRUSTe’s   Advertising   Choices   Page  to   opt-out   of
                        receiving tailored advertising from companies that participate in those programs
                        A web beacon is an invisible pixel-sized graphic image on a web page, web-based document or
                        e-mail message. It helps us do things like view the URL of the page on which the beacon appears
                        and the time the Platform, document or email in question is viewed. They can be used to confirm
                        the  receipt  of, and response  to, our emails, including those  that  you forward to friends and
                        family; and they help deliver a more personalized online experience.
                    </p>





                    <p style={{ ...textBold, ...textItalic }}>4.5 Information We Collect from Service Professionals </p>
                    <p>In   addition   to   the   information   identified   above,   we   may   also   collect   the   following   personal
                        information from service professionals (“Service Pros”):</p>
                    <div style={{
                        marginBottom: 20
                    }}>
                        {termsThree.map((term) => {
                            return (
                                <div style={{
                                    marginLeft: 20,
                                }}>
                                    <p style={{
                                        // fontWeight: '700'
                                    }}>{'\u2022'} {term}</p>
                                </div>
                            )
                        })}
                    </div>





                    <p style={{ ...textUnderline, ...mb10 }}>
                        5. How We Use and Share the Information We Collect
                    </p>

                    <p>ezPro uses the information we collect for various purposes:</p>

                    <div style={{
                        marginBottom: 20
                    }}>
                        {termsFour.map((term) => {
                            return (
                                <div style={{
                                    marginLeft: 20,
                                }}>
                                    <p style={{
                                        // fontWeight: '700'
                                    }}>{'\u2022'} {term}</p>
                                </div>
                            )
                        })}
                    </div>

                    <p>We may share your personal information:</p>
                    <p><p style={textBold}>
                        With your permission:</p>
                        We   may   share   personal   information   when   we   have   your
                        permission and as described herein.  ezPro will request your consent to these exchanges
                        on your behalf and you can change your mind at any time.</p>

                    <p><p style={textBold}>
                        Protection of rights:</p>We will share personal information if we have a good faith belief
                        that:   (i)   access,   use,   preservation   or   disclosure   of   such   information   is   reasonably
                        necessary to satisfy any applicable law, regulation, legal process, such as a court order or
                        subpoena, or a request by law enforcement or governmental authorities; (ii) such action is
                        appropriate   to   enforce   our   Terms   of   Use,   including   any   investigation   of   potential
                        violations thereof; (iii) such action is necessary to detect, prevent, or otherwise address
                        fraud, security or technical issues associated with the Platform; or (iv) such action is
                        appropriate to protect the rights, property or safety of us, our employees, users of the
                        Platform, or others.</p>

                    <p><p style={textBold}>
                        With Service Pros: </p>We share certain use information with the Service Pros in order to
                        facilitate the provision of services after a reservation is made.   The Service Pros are
                        contractually   obligated   to   protect   your   personal   information   in   compliance   with   this
                        Privacy Policy</p>

                    <p><p style={textBold}>
                        For authentication purposes:</p>We work with third-party vendors, including Facebook, to
                        provide social media login capabilities</p>

                    <p><p style={textBold}>
                        For external processing:</p>We have vendors, service providers, and technicians who help
                        with   some   of   our   processing   and   storage.   They   may   also   assist   with   monitoring   our
                        servers   for   technical   problems.   These   technicians   (as   well   as   ezPro   employees)   can
                        access certain information about you or your account in line with this work but these
                        technicians are not allowed to use this data for non-ezPro purposes.</p>

                    <p><p style={textBold}>
                        With our partners:</p>We may share non-personal information (for example, aggregated or
                        anonymized customer data) publicly and with our partners. For example, we may publish
                        trends.   This   information   may   also   be   shared   with   other   users   to   help   them   better
                        productivity,   raise   awareness   about   safety   issues,   or   help   us   generally   improve   our
                        system. We take steps to keep this non-personal information from being associated with
                        you and we require our partners to do the same</p>

                    <p><p style={textBold}>
                        Asset Transfers:</p>If we become involved in a merger, acquisition or other transaction
                        involving   the   sale   of   some   or   all   of   our   assets,   user   information,   including   personal
                        information collected from you through your use of the Platform, could be included in the
                        transferred assets.  You expressly consent to such transfer.  Should such an event occur,
                        we will use reasonable means to notify you through email and/or a prominent notice on
                        the Platform</p>









                    <p style={{ ...textUnderline, ...mb10 }}>
                        6. Your Privacy Choices
                    </p>
                    <p>
                        {`Generally, we will retain personal information for as long as your account is active or as needed
to provide you services. We may retain certain personal information indefinitely, unless you
delete it or request its deletion. You can request deletion of an inactive account through your
Profile   page   on   your   account   or   by   contacting   our   customer   support   team   at
admin@ezprohome.com.

If you no longer want to receive our emails or other announcements, you may unsubscribe by
writing to us at admin@ezprohome.com or by calling our customer service team at (916) 496-
3133 or following the instructions provided through the Platform or the “unsubscribe” link at the
bottom of our emails.  Please note that you cannot unsubscribe from certain correspondence from
us, including transactional messages relating directly to your account.

You may have the ability to turn location-based services on and off by adjusting the settings of
your web browser or mobile device.`}
                    </p>

                    <p style={{ ...textUnderline, ...mb10 }}>
                        7. How We Store and Safeguard Your Information
                    </p>
                    <p>
                        {`We take all commercially reasonable measures necessary to protect your personal information
from unauthorized access, alteration, or destruction; maintain data accuracy; and help ensure the
appropriate use of personal information.  All information you provide to us is stored in secure
managed servers, including Amazon Web Services, Dropbox, and Google Drive.  In the event of
a data breach that affects your personal information, we will act promptly to mitigate the impact
of a breach and notify you without undue delay.  

Where we have given you (or where you have chosen) a password which enables you to access
certain  parts  of  the   Site   or  App,  you  are   responsible   for  keeping  that   information  and  your
password confidential. We ask that you never share your password. 

No method of transmission, or method of electronic storage, is 100% secure.  Whenever you give
out personal information online, there is a risk that third parties may intercept and use that
information.     While   we   strive   to   protect   your   personal   information   and   privacy,   we   cannot
guarantee  the  security of any information you disclose  online.   By using our Platform, you
acknowledge and understand that despite best efforts, we cannot guarantee the security of any
data provided to or received by us and that any personal information, general information, or
other data or information received from you through the Platform is provided at your own risk.
We simply cannot guarantee its absolute security.`}
                    </p>



                    <p style={{ ...textUnderline, ...mb10 }}>8. How We Communicate with You</p>
                    <p>We will use your email address and telephone number to communicate with you.  For example,
                        if you contact our support team with a request, we may respond to you via email.   We may
                        communicate with you via text message regarding your reservation.</p>


                    <p style={{ ...textUnderline, ...mb10 }}>9. California Do-Not-Track Disclosure</p>
                    <p>Without changing or revoking any of your privacy protections contained in this Privacy Policy,
                        Venue Coalition respects your privacy, but we do not alter the information we collect or change
                        our services upon receiving “do-not-track” signals, as the term appears in Cal. Bus. & Prof. Code
                        §§ 22575(b)(5). For more information about DNT signals, visit http://allaboutdnt.com.</p>

                    <p style={{ ...textUnderline, ...mb10 }}>10. Links to Third Parties</p>
                    <p>
                        The Platform may contain hyperlinks to websites owned and operated by third parties.  Where
                        this is the case, we urge you to review the equivalent data protection, privacy and cookie policies
                        available   on   such   websites.     We   do   not   accept   any   responsibility   or   liability   for   the   data
                        protection of privacy practices of third parties in relation to such websites and your use of third-
                        party websites is entirely at your own risk.
                    </p>


                    <p style={{ ...textUnderline, ...mb10 }}>11. Contact Us</p>
                    <p>
                        f you have any questions or comments relating to the Platform or this Privacy Policy, you can
                        submit a question on our Site, send an email to <p style={{
                            color: '#0078ff'
                        }}>admin@ezprohome.com</p>, or call our customer
                        service team at (916) 496-3133
                    </p>


                    <p style={mt40}>Last updated: June 22, 2022</p>


                </div>
            </div>
        )
    }

    render() {
        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {/* {this.props.content} */}
                            {this.cancellationPrivacyContent()}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.props.handleYes}
                            color="primary"
                            autoFocus
                        >
                            Okay
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default CancellationPolicyAlert;



// WEBPACK FOOTER //
// ./src/components/Alert/CancellationPolicyAlert.jsx